<template>
  <v-card flat>
    <v-card-subtitle>
      <v-card flat color="grey lighten-3">
        <v-card-text>
          <v-row>
            <v-col>
              <row-info-concessao label="Cargo:" :value="concessao.cargo" />
              <row-info-concessao
                label="Período de Férias:"
                :value="
                  formatarData(concessao.dt_in_pg) +
                  ' a ' +
                  formatarData(concessao.dt_fi_pg)
                "
              />
              <row-info-concessao
                label="Período Aquisitivo:"
                :value="
                  formatarData(concessao.dt_in_paq) +
                  ' a ' +
                  formatarData(concessao.dt_fi_paq)
                "
              />
              <row-info-concessao
                label="Data Pagamento:"
                :value="formatarData(concessao.dt_pgto)"
              />

              <row-info-concessao
                label="Dias Gozados:"
                :value="concessao.dias_gozados"
              />

              <row-info-concessao
                label="Quantidade Abono(dias vendidos):"
                :value="concessao.dias_abono"
              />
            </v-col>
            <v-col xl="4" lg="4" md="4" sm="12" cols="12" align-self="center">
              <v-btn
                class="float-right"
                color="info"
                rounded
                @click="imprimirReciboFerias"
                :block="$mq === 'sm'"
              >
                <v-icon size="20" class="mr-2">mdi-printer</v-icon>
                Imprimir</v-btn
              >
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-subtitle>
    <v-card-text>
      <v-data-table :items="concessao.eventos" :headers="headers" :disable-sort="$mq == 'sm'">
        <template v-slot:[`item.valor`]="{ item }">
          {{ formatarMoeda(item.valor) }}
        </template>
        <template v-slot:[`item.base`]="{ item }">
          {{ formatarMoeda(item.base) }}
        </template>
      </v-data-table>
      <v-card flat class="grey lighten-3">
        <v-card-text>
          <v-row>
            <v-col xl="4" lg="4" md="4" sm="12" cols="12" class="pt-1 pb-1">
              <p class="mb-0">
                Vencimentos:
                <b>{{ formatarMoeda(concessao.tot_vencimentos) }}</b>
              </p>
            </v-col>
            <v-col xl="4" lg="4" md="4" sm="12" cols="12" class="pt-1 pb-1">
              <p class="mb-0">
                Descontos:
                <b class="red--text">{{
                  formatarMoeda(concessao.tot_descontos)
                }}</b>
              </p>
            </v-col>
            <v-col xl="4" lg="4" md="4" sm="12" cols="12" class="pt-1 pb-1">
              <p class="mb-0">
                Líquido a Receber:
                <b class="green--text">{{
                  formatarMoeda(concessao.tot_liq_receber)
                }}</b>
              </p>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-card-text>
  </v-card>
</template>

<script>
import { dateFormat, formatMoeda, getLinkImpressao, getToken } from "@/global";
import RowInfoConcessao from "./RowInfoConcessao.vue";

export default {
  components: { RowInfoConcessao },
  props: {
    concessao: Object,
  },
  data: () => ({
    headers: [
      {
        text: "Cód",
        value: "cod_evento",
      },
      {
        text: "Evento",
        value: "desc_evento",
      },
      {
        text: "Base Cálc",
        value: "base",
      },
      {
        text: "Valor",
        value: "valor",
      },
      {
        text: "",
        value: "operacao",
      },
    ],
  }),
  methods: {
    formatarMoeda(value) {
      return formatMoeda(value);
    },
    formatarData(value) {
      return dateFormat(value);
    },
    imprimirReciboFerias() {
      window.open(
        `${getLinkImpressao()}/recibo-ferias-pdf.php?token=${getToken()}&id=${
          this.concessao.id_concessao
        }&ano=${this.concessao.ano}`,
        "blank"
      );
    },
  },
};
</script>

<style>
</style>